<div class="main-wrapper">
    <div class="nav-wrapper">
        <app-nav-bar />
    </div>
    <div>
        <!-- Spacer for fixed header -->
        <div class="h-20"></div>
        <router-outlet />
        <app-footer />
    </div>
</div>
